import React from 'react';

import { MainContextProps } from './Main.types';

export const MainContext = React.createContext<MainContextProps>({} as MainContextProps);
